import styled from 'styled-components';

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  @media (max-width: 449px) {
    padding: 9px;
    justify-content: center;
    .line-icon {
      width: 20px;
      height: 20px;
    }
  }
`;

export { Icon };
